import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-89">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" aria-hidden="true" data-id="element-90" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-91">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#1A1A1A] border border-white/10 w-full max-w-2xl max-h-[80vh] rounded-xl shadow-2xl flex flex-col pointer-events-auto" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-92">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-white/5" data-id="element-93">
                <h2 id="modal-title" className="text-xl font-bold text-[#F5F0EB]" data-id="element-94">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-[#9A948C] hover:text-white hover:bg-white/5 rounded-full transition-colors" aria-label="Cerrar" data-id="element-95">
                  <X size={20} data-id="element-96" />
                </button>
              </div>

              {/* Content - Scrollable */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-[#9A948C] leading-relaxed space-y-4" data-id="element-97">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}